import * as React from 'react';
import * as Sentry from '@sentry/react';

export class ErrorField extends React.Component<any> {
    render() {
        const { code } = this.props;
        return (
            <div className="Error">
                <div className="Error-wrapper Error-wrapper-page">
                    <img
                        className="Error-wrapper-page-img"
                        src={window.config.img_file(`/images/error_${code}_${code === 404 ? 'v3' : 'v1'}.png`)}
                        alt={`Error ${code} page`}
                    />
                </div>
            </div>
        );
    }
}

export default (Target: React.ComponentClass) =>
    class extends React.Component {
        state: {
            err: any;
        } = {
            err: null,
        };

        componentDidCatch(err: any, info: React.ErrorInfo) {
            // Forward caught render errors to Sentry; this boundary degrades to ErrorField,
            // which would otherwise prevent the global handler from seeing the exception.
            // 这里的 ErrorBoundary 会降级为 ErrorField，导致全局 handler 收不到异常，需手动上报 Sentry
            if (Sentry?.captureException) {
                Sentry.withScope((scope) => {
                    scope.setTag('source', 'page-error-boundary');
                    scope.setContext('react', { componentStack: info?.componentStack });
                    Sentry.captureException(err instanceof Error ? err : new Error(String(err)));
                });
            }
            this.setState({ err });
        }

        render() {
            const { err } = this.state;
            return err ? <ErrorField code={err.errorCode || 404} /> : <Target {...this.props} />;
        }
    };
